import { Alert, Box, Button, Stack, Typography } from '@mui/joy';

import { ErrorRoot } from '@/components/router/ErrorContainer';
import { RouterLink } from '@/components/router/RouterLink';

export function NotFound() {
  return (
    <ErrorRoot>
      <Alert
        color="primary"
        // TODO
        // startDecorator={<BinocularsIcon size={40} />}
        sx={{ flex: 1 }}
        variant="soft"
        endDecorator={
          <Stack direction="row" gap={4}>
            <RouterLink to="/">Startseite</RouterLink>
            <Button onClick={() => window.history.back()}>Zurück</Button>
          </Stack>
        }
      >
        <Box>
          <Typography component="h1" level="h2">
            Seite nicht gefunden
          </Typography>
          <Typography>Die Seite konnte nicht gefunden werden.</Typography>
        </Box>
      </Alert>
    </ErrorRoot>
  );
}
